var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVrboGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_66",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.502 2.50049H27.5025V27.501H2.502V2.50049Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_66)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9455 22.7055L14.55 21.4335L11.832 8.29204C11.322 5.74204 11.5395 4.41604 12.3885 3.65854V3.61804H10.9215C10.4715 4.57204 10.3365 5.52604 10.854 8.04904L13.944 22.7055H13.9455ZM12.6945 25.242L13.3005 23.9835L9.9 8.01454C9.303 5.53204 9.438 4.39654 9.6825 3.61804H8.385C8.37143 4.96108 8.5451 6.29945 8.901 7.59454L12.693 25.242H12.6945ZM7.197 3.61804H5.67V3.65854C6.297 4.41904 6.519 5.33404 6.975 7.21504L6.978 7.23004L7.098 7.71754L11.175 26.541H12.0915L8.013 7.65604C7.66062 6.32754 7.38813 4.97913 7.197 3.61804ZM4.14 3.61804H2.502V3.65854C3.9975 4.24654 4.731 5.37604 5.322 8.02204L9.351 26.5335H10.269L6.2115 7.90654C5.5125 4.67254 4.779 4.07854 4.14 3.61804ZM24.975 3.61804C23.0445 4.74154 21.8955 6.81754 19.491 11.964L19.551 11.9985C22.3305 6.81754 23.9145 4.75354 27.501 3.67954V3.61804H24.975ZM19.3545 11.8635L19.4145 11.904L20.0745 10.3605C21.8265 6.24454 22.3935 4.91404 23.2275 3.65854V3.61804H21.3795V3.67204C21.57 5.81704 20.85 7.79254 19.3545 11.8635ZM15.1695 20.163L15.78 18.8835L13.707 8.35954C13.1295 5.39704 13.8225 4.10554 16.161 3.65854V3.61804H14.001C13.374 3.92854 12.0495 4.86304 12.7905 8.35354L15.1695 20.163ZM19.2945 11.823L19.2315 11.7825C20.5905 6.42454 20.1705 4.37554 18.132 3.65854V3.61804H19.932C21.21 4.90954 20.7435 7.02754 19.2945 11.823Z",
    fill: "#FBFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrboGrayIcon);
export default __webpack_public_path__ + "static/media/vrbo-gray-icon.0857b3a4c9de227b2da3119684414eae.svg";
export { ForwardRef as ReactComponent };